var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters['Loading/loadingStatus'])?_c('div',{staticClass:"span fixed-top"},[_c('b-progress',{staticClass:"p-0 m-0",attrs:{"id":"loading-3","value":_vm.percent(_vm.$store.getters['Loading/requestCounter']),"max":100,"height":"7px"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }